import React, {FC, useState} from 'react';
import axios from 'axios';
import ToastNotification from '../../../toastNotification';

export const ClContactForm: FC = () => {
  const [toastTitle, setToastTitle] = useState<string>('');
  const [toastContent, setToastContent] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [clientName, setClientName] = useState<string>('');
  const [clientEmail, setClientEmail] = useState<string>('');
  const [clientMessage, setClientMessage] = useState<string>('');
  const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  const clearInputState = () => {
    setClientName('');
    setClientEmail('');
    setClientMessage('');
  };
  const onSendEmailBtnClick = async () => {
    setIsLoading(true);
    if (emailRegex.test(clientEmail)) {
      await axios
        .post('https://nhan-portfolio-server.herokuapp.com/send-mail', {
          clientName: clientName,
          clientEmail: clientEmail.trim().toLocaleLowerCase(),
          clientMessage: clientMessage,
        })
        .then((response) => {
          if (response.status === 200) {
            setIsLoading(false);
            clearInputState();
            setToastTitle('Success');
            setToastContent(
              'Thank you for your contact me. Your message has been sent to me.',
            );
          } else {
            setIsLoading(false);
            clearInputState();
            setToastTitle('Error');
            setToastContent(
              'Sorry, my system is having an error. You can text to me via Skype or Facebook Messenger',
            );
          }
        })
        .catch(() => {
          setIsLoading(false);
          clearInputState();
          setToastTitle('Error');
          setToastContent(
            'Sorry, my system is having an error. You can text to me via Skype or Facebook Messenger',
          );
        });
    } else {
      setIsLoading(false);
      setToastTitle('Error');
      setToastContent(
        "Oops! Your email looks not correct. Let's check it again",
      );
    }
  };
  return (
    <>
      <div
        data-aos="fade-down"
        data-aos-duration="1000"
        className="text-input-item"
      >
        <input
          value={clientName}
          type="text"
          placeholder="Your Full Name"
          className="text-input"
          onChange={(e) => setClientName(e.target.value)}
        />
      </div>
      <div
        data-aos="fade-down"
        data-aos-duration="1000"
        className="text-input-item"
      >
        <input
          value={clientEmail}
          type="text"
          placeholder="Your Email"
          className="text-input"
          onChange={(e) => setClientEmail(e.target.value)}
        />
      </div>
      <div
        data-aos="fade-down"
        data-aos-duration="1000"
        className="text-input-item"
      >
        <textarea
          placeholder="Your Message"
          className="text-area-input"
          rows={5}
          onChange={(e) => setClientMessage(e.target.value)}
          value={clientMessage}
        />
      </div>
      <div data-aos="zoom-in" data-aos-duration="1000" className="button-item">
        <button
          className="download-resume"
          disabled={isLoading || !clientName || !clientEmail || !clientMessage}
          onClick={onSendEmailBtnClick}
        >
          {isLoading ? 'Your message is sending' : 'Send Message'}
        </button>
      </div>
      <ToastNotification
        toastContent={toastContent}
        toastTitle={toastTitle}
        setToastContent={setToastContent}
        setToastTitle={setToastTitle}
      />
    </>
  );
};
